import { Plane, Building2, CalendarDays, Compass, FileText, MapPin, UtensilsCrossed, HelpCircle, LifeBuoy, HandHeart } from "lucide-react";

// Fixed section definitions. Content for each is data-driven from the API.
export const SECTIONS = [
  { id: "travel", icon: Plane },
  { id: "hotels", icon: Building2 },
  { id: "itinerary", icon: CalendarDays },
  { id: "umrah", icon: Compass },
  { id: "janazah", icon: HandHeart },
  { id: "documents", icon: FileText },
  { id: "maps", icon: MapPin },
  { id: "food", icon: UtensilsCrossed },
  { id: "faq", icon: HelpCircle },
  { id: "support", icon: LifeBuoy },
];
